import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'accessibility',
  templateUrl: './accessibility.component.html',
  standalone: false,
})
export class AccessibilityComponent implements OnInit {
  constructor(private titleService: Title, public navigationService: NavigationService) {}
  ngOnInit(): void {
    this.titleService.setTitle('Accesibilidad');
  }
}
